module.exports = __webpack_public_path__ + "img/packages/labels-preview-laptop.a21caf.jpg";